import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { path } from 'ramda';

import {
  InputGroup,
  InputsRow,
  Label,
  TextInput,
  Link,
  Status,
} from 'components';

import classNames from 'classnames/bind';
import { templateParser } from 'utils/formatString';
import { debounce } from 'utils/common';
import { flatConnectionStates, checkFlatConnection } from '../../uttils/checkAddressHelper';

import Dropdown from '../Dropdown';

import { SET_ALLINONE_VALUE } from '../../../../constants';
import Ctx from '../../formText';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class AddressWrapper extends PureComponent {
  checkFlatConnection = debounce((flat) => {
    const {
      currentRegion,
      streetId,
      houseId,
      isNotAvailable,
      setFlatUsedState,
      setFlatPartnerConnected,
    } = this.props;
    const { street, house } = this.state;

    checkFlatConnection({
      city: {
        id: currentRegion.id,
        label: currentRegion.label,
      },
      street: {
        id: streetId,
        label: street,
      },
      house: {
        id: houseId,
        label: house,
        isConnected: !isNotAvailable,
      },
      flat,
    }).then(({ connectionState }) => {
      const flatAlreadyUsed = connectionState === flatConnectionStates.alreadyInUse;
      setFlatUsedState(flatAlreadyUsed);
      setFlatPartnerConnected(connectionState === flatConnectionStates.partnerConnected);
    });
  }, 150);

  constructor(props) {
    super(props);

    this.state = {
      flat: props.flat,
      house: '',
      street: '',
      region: props.currentRegion.label,
      newStreetPushed: false,
      newHousePushed: false,
      newFlatPushed: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { flatIsDisabled, streetId, houseId, currentRegion } = this.props;

    if (flatIsDisabled) {
      this.setState({ flat: '' });
    }

    if (currentRegion?.id !== undefined) {
      if (currentRegion?.id !== prevProps.currentRegion?.id) {
        setTimeout(() => this.streetInput.setFocus(), 20);
      }

      if (currentRegion?.label !== undefined) {
        this.setState({ region: currentRegion.label });
      }
    }

    if (streetId !== undefined && streetId !== prevProps.streetId) {
      setTimeout(() => this.houseInput.setFocus(), 20);
    }

    if (houseId !== undefined && prevProps.houseId !== this.props.houseId) {
      setTimeout(() => this.flatInput.setFocus(), 20);
    }
  }

  resetNotAvailableHomeStatus = () => {
    this.houseInput.clear();
  };

  handleChangeFlat = (flat) => {
    if (!this.state.newFlatPushed) {
      this.setState(
        { newFlatPushed: true },
        () => this.props.pushToAnalytics('NewFlat'),
      );
    }
    this.setState({ flat });
    this.props.setFlat(flat);
    this.props.setFlatPartnerConnected(false);

    this.checkFlatConnection(flat);
  };

  handleRegionChange = (payload) => {
    this.setState({ region: payload.label, street: '', house: '', flat: '' });
    this.props.setFlatPartnerConnected(false);
  };

  handleStreetChange = (payload) => {
    if (!this.state.newStreetPushed) {
      this.setState(
        { newStreetPushed: true },
        () => this.props.pushToAnalytics('NewStreet'),
      );
    }
    this.setState({ street: payload.label, house: '', flat: '' });
    this.props.setFlatPartnerConnected(false);
  };

  handleHouseChange = (payload, selected) => {
    if (!this.state.newHousePushed) {
      this.setState({ newHousePushed: true }, () => this.props.pushToAnalytics('NewHouse'));
    }
    if (selected) {
      this.props.pushToAnalytics('house', 'convForm', {
        eventLabel: `Дом ${payload.isConnected ? '' : 'не '}подключен`,
      });
    }
    this.setState({ house: payload.label });
    this.props.setFlatPartnerConnected(false);
  };

  render() {
    const {
      flatIsDisabled,
      flatAlreadyUsed,
      isFlatPartnerConnected,
      isNotAvailable,
      houseIsNotFound,
      streetIsNotFound,
      regionIsNotFound,
      className,
      regionStatus,
      streetStatus,
      houseStatus,
      flatStatus,
      street,
      houseData,
      texts,
      tariffNotFoundInRegion,
      tariffNotFoundInRegionMessage,
    } = this.props;
    const { street: streetName, flat } = this.state;

    return (
      <div className={cx('address', className)}>
        <div className={cx({ hidden: isNotAvailable })}>
          <InputsRow className={['nested', 'small']} groups={2}>
            <InputGroup className={cx('inputGroup')}>
              <InputsRow className={['nested', 'small']} groups={2}>
                <InputGroup className={cx('inputGroup')}>
                  <Label>
                    {Ctx.allInOne.requestForm.regionLabel}
                  </Label>
                  <Dropdown
                    name="NewRegion"
                    type="region"
                    size="default"
                    value={this.state.region}
                    onChange={this.handleRegionChange}
                    status={regionStatus}
                  />
                </InputGroup>
                <InputGroup className={cx('inputGroup')}>
                  <Label>
                    {Ctx.allInOne.requestForm.streetLabel}
                  </Label>
                  <Dropdown
                    type="street"
                    name="NewStreet"
                    size="default"
                    value={this.state.street}
                    onChange={this.handleStreetChange}
                    inputRef={(e) => { this.streetInput = e; }}
                    status={streetStatus}
                  />
                </InputGroup>
              </InputsRow>
            </InputGroup>

            <InputGroup className={cx('inputGroup')}>
              <InputsRow className={['nested', 'small']} groups={2}>
                <InputGroup className={cx('number')}>
                  <Label>{Ctx.allInOne.requestForm.homeLabel}</Label>
                  <Dropdown
                    name="NewHouse"
                    type="house"
                    size="default"
                    value={this.state.house}
                    onChange={this.handleHouseChange}
                    inputRef={(e) => { this.houseInput = e; }}
                    status={houseStatus}
                  />
                </InputGroup>
                <InputGroup className={cx('number')}>
                  <Label>{Ctx.allInOne.requestForm.flatLabel}</Label>
                  <TextInput
                    name="NewFlat"
                    onChange={this.handleChangeFlat}
                    disabled={flatIsDisabled || isNotAvailable}
                    value={this.state.flat}
                    autoComplete="off"
                    size="default"
                    status={flatStatus}
                    mask="_____"
                    ref={(e) => { this.flatInput = e; }}
                  />
                </InputGroup>
              </InputsRow>
            </InputGroup>
          </InputsRow>
        </div>

        {isNotAvailable && (
          <InputsRow>
            <Status emoji="statusFail" className={['wide', 'attention', cx('notAvailableHomeStatus')]}>
              <p>
                {Ctx.allInOne.requestForm.notAvailableHousePrefix}
                <Link onClick={this.resetNotAvailableHomeStatus}>
                  {street.label}
                  , дом
                  {houseData.label}
                </Link>
                {Ctx.allInOne.requestForm.notAvailableHousePostfix}
              </p>
            </Status>
          </InputsRow>
        )}
        {
          tariffNotFoundInRegion
          && (
            <InputsRow>
              <Status emoji="statusFail" className={['wide', 'attention']}>
                {tariffNotFoundInRegionMessage}
              </Status>
            </InputsRow>
          )
        }
        {
          regionIsNotFound
          && (
            <InputsRow>
              <Status emoji="statusFail" className={['wide', 'attention']}>
                {Ctx.allInOne.requestForm.regionIsNotFound}
              </Status>
            </InputsRow>
          )
        }
        {!regionIsNotFound && streetIsNotFound
          && (
            <InputsRow>
              <Status emoji="statusFail" className={['wide', 'attention']}>
                {Ctx.allInOne.requestForm.streetIsNotFound}
              </Status>
            </InputsRow>
          )}
        {!streetIsNotFound && houseIsNotFound
          && (
            <InputsRow>
              <Status emoji="statusFail" className={['wide', 'attention']}>
                {Ctx.allInOne.requestForm.houseIsNotFound}
              </Status>
            </InputsRow>
          )}

        {flatAlreadyUsed && (
          <InputsRow>
            <Status emoji="statusFail" className={['wide', 'attention']}>
              {texts.flatAlreadyUsed}
            </Status>
          </InputsRow>
        )}
        {isFlatPartnerConnected && (
          <InputsRow>
            <Status emoji="statusFail" className={['wide', 'attention', cx('flatPartnerConnected')]}>
              {templateParser(texts.flatPartnerConnected, {
                street: streetName,
                house: houseData && houseData.label,
                flat,
              })}
            </Status>
          </InputsRow>
        )}
      </div>
    );
  }
}

AddressWrapper.defaultProps = {
  isNotAvailable: false,
  houseIsNotFound: false,
  streetIsNotFound: false,
  regionIsNotFound: false,
  flatAlreadyUsed: false,
  isFlatPartnerConnected: false,
  className: '',
  flat: '',
};

const propTypesOneOfThree = PropTypes.oneOf(['default', 'ok', 'fail']);

AddressWrapper.propTypes = {
  setFlat: PropTypes.func.isRequired,
  flatIsDisabled: PropTypes.bool.isRequired,
  pushToAnalytics: PropTypes.func.isRequired,
  isNotAvailable: PropTypes.bool,
  houseIsNotFound: PropTypes.bool,
  streetIsNotFound: PropTypes.bool,
  regionIsNotFound: PropTypes.bool,

  className: PropTypes.string,
  flat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  currentRegion: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.number,
    label: PropTypes.string,
  }),
  texts: PropTypes.object,
  streetId: PropTypes.number,
  houseId: PropTypes.number,
  setFlatUsedState: PropTypes.func,
  setFlatPartnerConnected: PropTypes.func,
  isFlatPartnerConnected: PropTypes.bool,
  flatAlreadyUsed: PropTypes.bool,
  regionStatus: propTypesOneOfThree,
  streetStatus: propTypesOneOfThree,
  houseStatus: propTypesOneOfThree,
  flatStatus: propTypesOneOfThree,
  street: PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.number,
  }),
  houseData: PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.number,
  }),
  tariffNotFoundInRegion: PropTypes.bool,
  tariffNotFoundInRegionMessage: PropTypes.string,
};

const mapStateToProps = ({ home }) => {
  // reSelect
  const { allInOne = {} } = home;
  const street = path(['street'], allInOne) || {};
  const house = path(['house'], allInOne) || {};

  return ({
    texts: path(['serverData', 'texts'], allInOne),
    flat: allInOne.flat,
    activeIndex: allInOne.activeIndex,
    isNotAvailable: house.id && !house.isConnected,
    houseIsNotFound: allInOne.houseIsNotFound,
    serverData: allInOne.serverData,
    flatIsDisabled: !path(['street', 'id'], allInOne) || !house.id,
    streetId: path(['street', 'id'], allInOne),
    houseId: path(['house', 'id'], allInOne),
    flatAlreadyUsed: allInOne.flatAlreadyUsed,
    isFlatPartnerConnected: allInOne.isFlatPartnerConnected,
    currentRegion: path(['region'], allInOne),
    houseData: house,
    street,
    tariffNotFoundInRegion: path(['tariffNotFoundInRegion'], allInOne) || false,
    tariffNotFoundInRegionMessage: path(['tariffNotFoundInRegionMessage'], allInOne) || '',
  });
};

const mapDispatchToProps = (dispatch) => (
  {
    setFlat: (flat) => dispatch({
      type: SET_ALLINONE_VALUE,
      resetError: true,
      payload: {
        flat,
      },
    }),
    setFlatUsedState: (flatAlreadyUsed) => dispatch({
      type: SET_ALLINONE_VALUE,
      payload: { flatAlreadyUsed },
    }),
    setFlatPartnerConnected: (isFlatPartnerConnected) => dispatch({
      type: SET_ALLINONE_VALUE,
      payload: { isFlatPartnerConnected },
    }),
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(AddressWrapper);
